/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SolidOps API
 * OpenAPI spec version: 1.0.0
 */
import * as zod from 'zod';

export const phoneProgressResponseOutputOneIncidentIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const phoneProgressResponseOutputTwoCallIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const phoneProgressResponseOutputTwoIncidentIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const phoneProgressResponseOutputTwoVersionExclusiveMin = 0;
export const phoneProgressResponseOutputTwoVersionMax = 9007199254740991;

export const phoneProgressResponseOutputTwoReceivedAtRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const phoneProgressResponseOutputTwoCallerNumberOneRegExp = new RegExp(
  '^\\+[1-9][0-9]{1,14}$',
);
export const phoneProgressResponseOutputTwoDialedNumberOneRegExp = new RegExp(
  '^\\+[1-9][0-9]{1,14}$',
);
export const phoneProgressResponseOutputTwoOriginalTeamOneIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const phoneProgressResponseOutputTwoOriginalTeamOneNameMax = 250;

export const phoneProgressResponseOutputTwoSelectedAgentOneIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const phoneProgressResponseOutputTwoSelectedAgentOneNameMax = 250;

export const phoneProgressResponseOutputTwoIdentificationCustomerOneIdRegExp = new RegExp(
  '^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$',
);
export const phoneProgressResponseOutputTwoIdentificationCustomerOneNameMax = 250;

export const phoneProgressResponseOutputTwoStageTwoRingingAtRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const phoneProgressResponseOutputTwoStageThreeAcceptedAtRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const phoneProgressResponseOutputTwoStageFourAcceptedAtRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const phoneProgressResponseOutputTwoStageFourConnectedAtRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const phoneProgressResponseOutputTwoStageFiveEndedAtRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);
export const phoneProgressResponseOutputTwoStageFiveConnectedAtOneRegExp = new RegExp(
  '^(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))T(?:(?:[01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d(?:\\.\\d+)?(?:Z|([+-](?:[01]\\d|2[0-3]):[0-5]\\d)))$',
);

export const PhoneProgressResponseOutput = zod.union([
  zod.object({
    kind: zod.literal('no-phone'),
    incidentId: zod.uuid().regex(phoneProgressResponseOutputOneIncidentIdRegExp),
  }),
  zod.object({
    kind: zod.literal('phone'),
    callId: zod.uuid().regex(phoneProgressResponseOutputTwoCallIdRegExp),
    incidentId: zod.uuid().regex(phoneProgressResponseOutputTwoIncidentIdRegExp),
    version: zod
      .int()
      .gt(phoneProgressResponseOutputTwoVersionExclusiveMin)
      .max(phoneProgressResponseOutputTwoVersionMax),
    receivedAt: zod.iso
      .datetime({ offset: true })
      .regex(phoneProgressResponseOutputTwoReceivedAtRegExp),
    callerNumber: zod.union([
      zod.string().regex(phoneProgressResponseOutputTwoCallerNumberOneRegExp),
      zod.null(),
    ]),
    callerNumberOutcome: zod.enum(['available', 'withheld', 'invalid', 'unavailable']),
    dialedNumber: zod.union([
      zod.string().regex(phoneProgressResponseOutputTwoDialedNumberOneRegExp),
      zod.null(),
    ]),
    originalTeam: zod.union([
      zod.object({
        id: zod.uuid().regex(phoneProgressResponseOutputTwoOriginalTeamOneIdRegExp),
        name: zod.string().min(1).max(phoneProgressResponseOutputTwoOriginalTeamOneNameMax),
      }),
      zod.null(),
    ]),
    selectedAgent: zod.union([
      zod.object({
        id: zod.uuid().regex(phoneProgressResponseOutputTwoSelectedAgentOneIdRegExp),
        name: zod.string().min(1).max(phoneProgressResponseOutputTwoSelectedAgentOneNameMax),
      }),
      zod.null(),
    ]),
    identification: zod.object({
      method: zod.union([zod.enum(['number', 'code', 'manual']), zod.null()]),
      outcome: zod.enum([
        'matched',
        'unknown',
        'withheld',
        'invalid',
        'archived-only',
        'ambiguous',
        'unavailable',
      ]),
      customer: zod.union([
        zod.object({
          id: zod.uuid().regex(phoneProgressResponseOutputTwoIdentificationCustomerOneIdRegExp),
          name: zod
            .string()
            .min(1)
            .max(phoneProgressResponseOutputTwoIdentificationCustomerOneNameMax),
        }),
        zod.null(),
      ]),
    }),
    stage: zod.union([
      zod.object({
        kind: zod.literal('preparing'),
      }),
      zod.object({
        kind: zod.literal('ringing'),
        ringingAt: zod.iso
          .datetime({ offset: true })
          .regex(phoneProgressResponseOutputTwoStageTwoRingingAtRegExp),
      }),
      zod.object({
        kind: zod.literal('accepted-waiting'),
        acceptedAt: zod.iso
          .datetime({ offset: true })
          .regex(phoneProgressResponseOutputTwoStageThreeAcceptedAtRegExp),
      }),
      zod.object({
        kind: zod.literal('connected'),
        acceptedAt: zod.iso
          .datetime({ offset: true })
          .regex(phoneProgressResponseOutputTwoStageFourAcceptedAtRegExp),
        connectedAt: zod.iso
          .datetime({ offset: true })
          .regex(phoneProgressResponseOutputTwoStageFourConnectedAtRegExp),
      }),
      zod.object({
        kind: zod.literal('ended'),
        endedAt: zod.iso
          .datetime({ offset: true })
          .regex(phoneProgressResponseOutputTwoStageFiveEndedAtRegExp),
        connectedAt: zod.union([
          zod.iso
            .datetime({ offset: true })
            .regex(phoneProgressResponseOutputTwoStageFiveConnectedAtOneRegExp),
          zod.null(),
        ]),
      }),
      zod.object({
        kind: zod.literal('voicemail-required'),
        reason: zod.enum([
          'no-eligible-agent',
          'unavailable',
          'setup-failed',
          'submission-unknown',
          'busy',
          'no-answer',
          'acceptance-expired',
          'declined',
          'caller-ended',
          'agent-ended',
          'preparation-expired',
          'handoff-unavailable',
        ]),
      }),
      zod.object({
        kind: zod.literal('handoff-unavailable'),
        reason: zod.literal('handoff-unavailable'),
      }),
    ]),
    failureReason: zod.union([
      zod.enum([
        'no-eligible-agent',
        'unavailable',
        'setup-failed',
        'submission-unknown',
        'busy',
        'no-answer',
        'acceptance-expired',
        'declined',
        'caller-ended',
        'agent-ended',
        'preparation-expired',
        'handoff-unavailable',
      ]),
      zod.null(),
    ]),
    voicemailHandoffUnavailable: zod.boolean(),
  }),
]);

export type PhoneProgressResponseOutput = zod.input<typeof PhoneProgressResponseOutput>;
export type PhoneProgressResponseOutputOutput = zod.output<typeof PhoneProgressResponseOutput>;
